// Shared Work Authorization / Visa options used across job listings,
// candidate profiles, the Careers filter, and the Admin dashboard.
export const WORK_AUTH_OPTIONS = [
  "H-1B",
  "H-1B Transfer",
  "H-1B Sponsorship",
  "H-1B Cap-Exempt",
  "H-4 EAD",
  "L-1",
  "L-2 EAD",
  "E-3",
  "O-1",
  "TN",
  "F-1 OPT",
  "F-1 STEM OPT",
  "J-1",
  "J-2 EAD",
  "EAD",
  "Green Card",
  "U.S. Citizen",
  "Permanent Resident",
  "Asylee/Refugee EAD",
  "TPS EAD",
  "Other EAD",
  "CPT",
  "No Sponsorship Required",
  "Sponsorship Available",
  "Sponsorship Not Available",
  "Visa Transfer Available",
  "Open to All Work Authorizations",
];

// Value that means a job accepts candidates with any work authorization.
export const WORK_AUTH_OPEN = "Open to All Work Authorizations";
